export const STARTUP_COMMAND_ARGS_FIELD_KEYS = {
  command: 'startupCommandArgs.command',
  list: 'startupCommandArgs.list',
} as const;

export const STARTUP_COMMAND_ARGS_FIELD_KEY_LIST = [STARTUP_COMMAND_ARGS_FIELD_KEYS.command, STARTUP_COMMAND_ARGS_FIELD_KEYS.list] as const;

export const STARTUP_COMMAND_ARGS_ACTION_KEYS = {
  addPreset: 'startupCommandArgs.addPreset',
  addCustom: 'startupCommandArgs.addCustom',
  remove: 'startupCommandArgs.remove',
} as const;

export const STARTUP_COMMAND_ARGS_ACTION_KEY_LIST = Object.values(STARTUP_COMMAND_ARGS_ACTION_KEYS);
